// If the user is logged in, fall through. Otherwise, if `?access_token=` is in
// the URL, exchange it for a session cookie. If both fail, redirect to /login.
export default defineNuxtRouteMiddleware(async (to) => {
  const { loggedIn, fetch: refreshSession } = useUserSession()

  if (loggedIn.value) return

  const token = (to.query.access_token ?? to.query.accessToken) as string | undefined
  if (token && typeof token === 'string' && token.trim().length >= 16) {
    try {
      await $fetch('/api/auth/token-login', { method: 'POST', body: { token: token.trim() } })
      await refreshSession()
      if (loggedIn.value) {
        // Strip token from URL for cleanliness — keep the path/hash intact.
        const cleaned = { ...to.query }
        delete cleaned.access_token
        delete cleaned.accessToken
        return navigateTo({ path: to.path, query: cleaned, hash: to.hash }, { replace: true })
      }
    } catch { /* fall through to login redirect */ }
  }

  return navigateTo('/login')
})
